export const CERISE_INVALID_URL_ERROR_MESSAGE =
  "Les url's Cerise ne sont pas autorisées";
export const MEDIA_TEXT_FIELD_PLACEHOLDER =
  "Collez l'URL d'un média et appuyez sur Entrer";
